import { render, staticRenderFns } from "./UserEditZones.vue?vue&type=template&id=6a1ec4fd&"
import script from "./UserEditZones.vue?vue&type=script&lang=js&"
export * from "./UserEditZones.vue?vue&type=script&lang=js&"
import style0 from "./UserEditZones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports